import { type OlkTimeAndPlacesErrorCodes } from "owa-error-codes";
import { getEntryPoint } from "hybridspace-telemetry";
import { DatapointStatus, PerformanceDatapoint } from "owa-analytics";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { query } from "owa-apollo";

import { ApolloError, type ApolloQueryResult, type OperationVariables, type TypedDocumentNode, } from "@apollo/client";
import type { OperationDefinitionNode } from "graphql";
import type { StrictQueryOptions } from "owa-apollo";
import type { CustomData } from "owa-analytics-types";
interface CustomOptions {
    shouldLog?: (error: ApolloError) => boolean;
    customData?: CustomData;
}

export async function queryWithError<TSchemaVars extends OperationVariables, TActualVars extends import("owa-graph-schema").Exact<TSchemaVars>, TData>(queryDoc: TypedDocumentNode<TData, TSchemaVars>, options: StrictQueryOptions<TActualVars, TData> = {}, customOptions: CustomOptions = {}): Promise<ApolloQueryResult<TData>> {
    const operationName = (queryDoc.definitions[0] as OperationDefinitionNode)?.name?.value;
    const perfDatapoint = new PerformanceDatapoint("PlacesQueryWithError", getModuleContextMailboxInfo());
    const customData = customOptions?.customData;
    perfDatapoint.addCustomData({
        entryPoint: getEntryPoint(),
        operationName,
        ...customData,
    });
    let schemaResult: ApolloQueryResult<TData>;
    try {
        schemaResult = await query(queryDoc, options);
        const resultError = schemaResult?.error;
        if (resultError) {
            const graphqlError = resultError.graphQLErrors?.[0];
            const networkError = resultError.networkError;
            perfDatapoint.endWithError(networkError || (graphqlError?.extensions?.code?.indexOf("SERVER") ?? 0) > -1
                ? DatapointStatus.ServerError
                : DatapointStatus.ClientError, "39_0100");
            throw new ApolloError(resultError);
        }
        else {
            perfDatapoint.end();
        }
    }
    catch (error) {
        // Errors resulting from enabling useUnknownInCatchVariables
        // TS2345: Argument of type 'unknown' is not assignable to parameter of type 'TraceErrorObject | ErrorCodes'.
        // @ts-expect-error
        perfDatapoint.endWithError(DatapointStatus.ServerError, error);
        throw error;
    }
    
    return schemaResult as ApolloQueryResult<TData>;
}
